import React from "react";
import { TableCell, TableRow } from "@mui/material";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";

const ChartOfAccountList = ({ item }) => {
    return (
        <TableRow>
            <TableCell><div style={{ width: item?.name?.length > 50 ? "200px" : '' }}><LessMoreComp name={item?.name || "--"} lessMr='name' /></div></TableCell>
            <TableCell>{item?.company_name || "--"}</TableCell>
            <TableCell>{item?.account_type || "--"}</TableCell>
            <TableCell>{item?.fully_qualified_name || "--"}</TableCell>
            <TableCell><LessMoreComp name={item?.description || "--"} lessMr="description" /></TableCell>
        </TableRow>
    );
};

export default ChartOfAccountList
